/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CHECK_PAYMENT_FROM_PG } from "../graphql/checkPaymentFromPG.query";
import { CHECK_PAYMENT_FROM_PG_FAC } from "../graphql/checkPaymentFAC.query";
import { VERIFY_PAYMENT } from "../graphql/verifyPayment.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICheckPaymentFromPGTypeMethods extends IPluginMethodMap {
  checkPaymentFromPG(args: any): Promise<any>;
}

export class CheckPaymentFromPGService implements IAgentPlugin {
  readonly methods: ICheckPaymentFromPGTypeMethods;

  constructor() {
    this.methods = {
      checkPaymentFromPG: this.checkPaymentFromPG.bind(this),
    };
  }

  async checkPaymentFromPG(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageService = StorageModule.getInstance();
    console.log("Here ", args);

    try {
      if (client) {
        if (storageService.get("currencyExchangeLocal", "local")?.provider === "FAC") {
          const res = await client.query({
            query: CHECK_PAYMENT_FROM_PG_FAC,
            variables: {
              txnId: args?.id,
              // status: args?.status,
            },
            fetchPolicy: "network-only",
          });

          if (
            res?.data?.getFACPaymentFromPG &&
            is.existy(res?.data?.getFACPaymentFromPG)
          ) {
            return res?.data?.getFACPaymentFromPG;
          }
        } else if (storageService.get("currencyExchangeLocal", "local")?.provider === "CAL" || storageService.get("currencyExchangeLocal", "local")?.provider === "CALKIDS") {
          const res = await client.mutate({
            mutation: VERIFY_PAYMENT,
            variables: {
              paymentId: args?.id,
              cStatus: args?.status,
            },
            fetchPolicy: "no-cache",
          });
          if (
            res?.data?.verifyPayment &&
            is.existy(res?.data?.verifyPayment)
          ) {
            return { ...res?.data?.verifyPayment };
          }
        } else {
          const res = await client.query({
            query: CHECK_PAYMENT_FROM_PG,
            variables: {
              txnId: args?.id,
              status: args?.status,
            },
            fetchPolicy: "network-only",
          });

          if (
            res?.data?.checkPaymentFromPG &&
            is.existy(res?.data?.checkPaymentFromPG)
          ) {
            return res?.data?.checkPaymentFromPG;
          }
        }

      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
